export enum SettingsSectionKey {
    VirtualBackground = 'VirtualBackground',
    Account = 'Account',
    Sound = 'Sound',
    Camera = 'Camera',
    Help = 'Help',
    Theme = 'Theme',
    Permissions = 'Permissions',
    Developers = 'Developers',
    Diagnostics = 'Diagnostics',
}

export enum HiddenStatus {
    always = 'always',
    no = 'no',
    unknown = 'unknown',
}

export enum SubmodalId {
    PERMISSIONS_EXTENDED_RETURN_TO_DEFAULT = 'permissions-extended-return-to-default',
    PERMISSIONS_EXTENDED_RESET = 'permissions-extended-reset',
}

export const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
